import { Pipe, PipeTransform } from '@angular/core';
/**
 * Converts camelcase string to a slug: lower-case + kebab-case (i.e. separating words with dashes).
 *
 * For QA automation IDs.
 * Intended for usage with camelcase strings from model properties.
 *
 * Example: "otherUser24NameABC1" => "other-user-24-name-abc-1"
 *
 * Usage: {{ value | qaSlug }}
 *
 * Explanation of Regex & capture groups: https://stackoverflow.com/a/15370765
 */
@Pipe({ name: 'qaSlug' })
export class QaSlugPipe implements PipeTransform {
  transform(value: any): any {
    const camelCase = /([A-Z])([A-Z])([a-z])|([a-z])([A-Z])/g;
    const alphaNumeric = /([0-9]+)([a-zA-Z])/g;
    const uppercase = /[A-Z]/g;
    const appendedIndex = /([a-z])([0-9])/g;

    return String(value)
      .trim()
      .replace('_', '-') // replace underscores (e.g. see Expenses) with dashes
      .replace(camelCase, '$1$4-$2$3$5') // convert words to kebab-case
      .replace(alphaNumeric, '$1-$2') // convert alphanumeric to kebab-case
      .replace(uppercase, (letter) => `${letter.toLowerCase()}`) // convert words to lower-case
      .replace(appendedIndex, '$1-$2'); // convert to kebab-case (between last word and appended index)
  }
}
